module.exports = __webpack_public_path__ + "img/beeequal.7f102751.svg";